<style lang="less"></style>

<template>
    <MenuList sidebarClassName="export-menu-item" :menuList="menuList" @handleClicks="handleClicks(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class PlaySliderDrops extends Vue {
        get menuList() {
            let list = [{ key: "playFromHead" }, { key: "playFromCurrent" }];
            let resultList = [];
            list.map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "playFromHead",
                    () => {
                        event.stopPropagation();
                        this.$emit("playFromHead");
                    },
                ],
                [
                    "playFromCurrent",
                    () => {
                        event.stopPropagation();
                        this.$emit("playFromCurrent");
                    },
                ],
            ]);

            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        closeDrop() {
            this.$emit("closeDrop");
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "playFromHead": "从头演示",
    "playFromCurrent": "从当前演示"
  },
  "en": {
    "playFromHead": "Show From Start",
    "playFromCurrent": "Show From Current Page"
  },
  "fr": {
    "playFromHead": "Depuis le début",
    "playFromCurrent": "Depuis la page actuelle"
  },
  "de": {
    "playFromHead": "Von Beginn an",
    "playFromCurrent": "Ab aktueller Seite"
  },
  "jp": {
    "playFromHead": "最初から",
    "playFromCurrent": "現在のページから"
  },
  "es": {
    "playFromHead": "Desde Inicio",
    "playFromCurrent": "Desde página actual"
  },
  "pt": {
    "playFromHead": "Do início",
    "playFromCurrent": "Da página atual"
  },
  "it": {
    "playFromHead": "Dall'inizio",
    "playFromCurrent": "Dalla pagina corrente"
  }
}
</i18n>
